import {User} from "../../user";

export class UserSearch extends User {
    constructor() {
        super();
    }
}
